const COPY = {
  Landing: 'Start tracking your weight and benefit from joining the campaign',
  Terms1:
    'This application will allow you to claim and securely store your personal data and view your Data Passes. The pass can be used to obtain Offers from participating businesses.',
  Terms2:
    'We use <a href="https://www.hubofallthings.com/">Data Accounts (PDAs)</a> powered by the <a href="https://www.hubofallthings.com/main/what-is-the-hat">HAT Microserver technology</a> to give you control and legal rights over your data. By proceeding to you agree to:',
  Terms3:
    'Learn how we protect your data: Your Personal Data Account enables you to own data rights for reuse and sharing with applications. For more information on the technology that power PDAs, please visit ',
  PriceText: 'By transacting on this Data Pass you agree to pay this price:',
  Perks: 'Pass Offers',
  PerksText: 'View the full list of Offers ',
  ClaimTitle: 'Data Pass Information',
  ClaimText:
    'This Data Pass uses your Profile information for activation.  Please note, that the data does not leave your Personal Data Server.',
  ClaimButton: 'I wish to proceed and activate this Data Pass',
  ClaimError: 'Oops, something went wrong!',
  ClaimError2: 'If you continue to see this message, ',
  ClaimSearchAgain: 'Please try searching for your details again.',
  ClaimSearchAgainButton: 'Search again',
  ClaimConfirmText: 'Please confirm your correct details:',
  ClaimConfirmButton: 'These are my details',
  ClaimConfirmSearchAgain: 'Not quite, search again',
  ClaimSearchTitle: 'Activate your Data Pass from {0} to enjoy rewards and benefits.',
  ClaimSearchText:
    'Before you can enjoy your benefit, we need you to verify that you are eligible for the Data Pass with the following information:',
  // Claim Data Variables
  ClaimFormLabel1: 'Last Name',
  ClaimResultLabel1: 'First Name',
  ClaimFormLabel4: 'First Name',
  ClaimResultLabel4: 'First Name',
  ClaimFormName1: 'last_name',
  ClaimFormLabel2: 'Email',
  ClaimFormName2: 'email',
  ClaimFormLabel3: 'Street Address',
  ClaimFormName3: 'address',
  SelectPass: 'Select the Data Pass you wish to view or activate:',
  TransactPass: 'Select the Data Pass you wish to transact on:',
  // Pass Status Labels
  active_label_1: 'Activated',
  active_label_2: '',
  inactive_label_1: 'Not Activated',
  inactive_label_2: '',
  // Customer Info List items
  customer_info_item_1: 'Track the progress of your weight loss',
  customer_info_item_2: 'Go to the Data Passport section to view Data Passes and the available offers',
  customer_info_item_3:
    'Activate a Data Pass and qualify yourself for the offers',
  customer_info_item_4: 'Redeem your offers by showing your Data Pass to merchants',
  // Button text
  customer_perk_text: 'View all Offers',
  merchant_perk_text: 'View Offers or add one',
};

export default COPY;
